import { Grid } from "@material-ui/core";
import React from "react";

interface Props {
  condition: boolean;
  className?: string;
}

export const ConditionalGrid: React.FC<Props> = (props) => {
  const { condition, children, className } = props;

  if (condition) {
    return (
      <Grid container direction="column" className={className}>
        {children}
      </Grid>
    );
  }
  return null;
};
